import React from "react";
import { IoCloseOutline } from "react-icons/io5";
import { TimePicker } from "antd";
import dayjs from "dayjs";

const MealRow = ({ meal, onChange, onRemove }) => {
  return (
    <div className="grid grid-cols-12 gap-3 items-center">
      <div className="col-span-2">
        <TimePicker
          use12Hours
          format="h:mm a"
          className="w-full rounded-lg px-2 py-2 text-xs outline-none focus:border-brand-primaryColor"
          value={meal.mealTime ? dayjs(meal.mealTime, "HH:mm") : null}
          onChange={(time, timeString) => onChange("mealTime", time ? time.format("HH:mm") : "")}
          needConfirm={false}
          allowClear={false}
        />
      </div>

      <div className="col-span-3">
        <select
          value={meal.mealType}
          onChange={(e) => onChange("mealType", e.target.value)}
          className="w-full border rounded-lg px-2 py-2 text-xs outline-none focus:border-brand-primaryColor"
        >
          <option value="">Select Type</option>
          <option value="Early Morning">Early Morning</option>
          <option value="Breakfast">Breakfast</option>
          <option value="Mid Morning">Mid Morning</option>
          <option value="Lunch">Lunch</option>
          <option value="Evening Snack">Evening Snack</option>
          <option value="Dinner">Dinner</option>
          <option value="Bedtime">Bedtime</option>
        </select>
      </div>

      <div className="col-span-6">
        <input
          placeholder="Enter meal/menu details"
          value={meal.meal}
          onChange={(e) => onChange("meal", e.target.value)}
          className="w-full border rounded-lg px-3 py-2 text-xs outline-none focus:border-brand-primaryColor"
        />
      </div>

      <div className="col-span-1 flex justify-center">
        {onRemove && (
          <button
            onClick={onRemove}
            className="text-red-500 hover:text-red-700 transition-colors bg-white"
          >
            <IoCloseOutline className="w-4 h-4" />
          </button>
        )}
      </div>
    </div>
  );
};

export default MealRow;
